module.exports = __webpack_public_path__ + "static/media/2@2x.0792f25e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_148/img/2@2x.png
// module id = 1423
// module chunks = 0